import { render, staticRenderFns } from "./table-1.vue?vue&type=template&id=b8cb203c&scoped=true"
import script from "./table-1.vue?vue&type=script&lang=js"
export * from "./table-1.vue?vue&type=script&lang=js"
import style0 from "./table-1.vue?vue&type=style&index=0&id=b8cb203c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cb203c",
  null
  
)

export default component.exports